module.exports = __webpack_public_path__ + "img/recommended_04.b99af965.webp";